import React from 'react'
import { Dialog, Flex, Button } from 'components/ds'

export const RemoveRecipientConfirmation = ({
  onClose,
}: {
  onClose: (removeRecipient: boolean) => void
}) => {
  return (
    <Dialog.Root defaultOpen>
      <Dialog.Content maxWidth="400px">
        <Dialog.Title>Remove recipient?</Dialog.Title>
        <Dialog.Description>
          Removing this recipient will revoke their access to this brief.
          However, any submissions they’ve made will remain in your submissions
          folder.
        </Dialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <Dialog.Close>
            <Button
              variant="soft"
              color="gray"
              onClick={() => {
                onClose(false)
              }}
            >
              Cancel
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button
              color="red"
              onClick={() => {
                onClose(true)
              }}
            >
              Remove
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
